import { createContext } from 'react';

export const SearchDataContext = createContext({
  countGuests: undefined,
  childrenAges: undefined,
  withPet: undefined,
  onChangeDates: () => {},
  onChangeCountGuests: () => {},
  onChangeChildrenAges: () => {},
  onChangeWithPet: () => {},
});
